import { useQuery } from '@tanstack/react-query'
import { apis } from '@/modules/apiClients'
import { organizationsQueryKeys } from '@/storeHooks/useOrganizations'

export const useOrgBranding = (organizationId: string | undefined) => {
    const { data, isLoading } = useQuery({
        queryKey: organizationsQueryKeys.branding(organizationId || ''),
        queryFn: async () => {
            if (!organizationId) throw new Error('Organization ID is required')
            return await apis.partnerService.organizationsOrganizationIdBrandingGet(organizationId)
        },
        enabled: !!organizationId,
        staleTime: 30 * 60 * 1000, // 30 minutes — logos rarely change
    })

    return {
        branding: data?.data.data,
        isLoading,
    }
}
